import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "text-primary-dark mb-2 border-bottom pb-2",
  "data-test-ref": "password-help-title"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-check-circle fs-lg mr-2",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "p-0 m-0" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-check-circle fs-lg mr-2",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "p-0 m-0" }
const _hoisted_9 = { class: "mt-3" }
const _hoisted_10 = {
  href: "tel:{{ t('passwordHelp.link.technicalSupportNumber') }}",
  "data-test-ref": "password-help-call-support-link"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "border-top my-3" }, null, -1 /* HOISTED */)
const _hoisted_12 = { class: "d-flex justify-content-end mb-4" }
const _hoisted_13 = {
  key: 1,
  "data-test-ref": "submit-forgot-username-twin-alert"
}
const _hoisted_14 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_17 = {
  key: 2,
  "data-test-ref": "submit-forgot-username-subscriberError-alert"
}
const _hoisted_18 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_21 = { class: "mr-1" }
const _hoisted_22 = {
  key: 3,
  "data-test-ref": "submit-forgot-username-system-alert"
}
const _hoisted_23 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-triangle fs-lg mr-3 p-0",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_29 = {
  key: 5,
  class: "flex-column"
}
const _hoisted_30 = {
  class: "pt-3",
  "data-test-ref": "password-help-description"
}
const _hoisted_31 = { class: "d-flex flex-wrap" }
const _hoisted_32 = { class: "flex-grow-1 min-w-0" }
const _hoisted_33 = {
  key: 0,
  class: "d-block invalid-feedback",
  "data-test-ref": "username-error"
}
const _hoisted_34 = { class: "fs-sm mt-2 mb-4" }
const _hoisted_35 = {
  key: 1,
  class: "mt-0 fs-sm text-secondary",
  "data-test-ref": "dateofbirth-date-error"
}
const _hoisted_36 = {
  key: 2,
  class: "mt-0 d-block invalid-feedback",
  "data-test-ref": "dateofbirth-error"
}
const _hoisted_37 = {
  key: 4,
  "data-test-ref": "firstName-required-message",
  class: "text-danger mt-0"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "border-top my-3" }, null, -1 /* HOISTED */)
const _hoisted_39 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", {
  class: "fas fa-chevron-right",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_41 = { "data-test-ref": "password-help-text" }
const _hoisted_42 = {
  href: "tel:{{ t('passwordHelp.link.technicalSupportNumber') }}",
  "data-test-ref": "password-help-call-support-link"
}

import { PropType, reactive, ref, watch } from 'vue';
import { mergeMessages, useI18n } from '@/i18n';
import { useVuelidate } from '@vuelidate/core';
import { AxiosError } from 'axios';
import * as logger from 'commercial-web-client-utilities/dist/logging/logger';
import { useNonsecureService } from 'commercial-web-client-utilities/dist/composables/nonsecure-service';
import { forgotPasswordRules } from 'commercial-web-client-utilities/dist/member/index';
import { createPasswordHelpService } from '@/composables/password-help';
import FaqModal from '@/components/common/faq-modal.vue';
import { useAppStore, useLoginHelpStore } from '@/store';
import { useSiteConfig } from '@/composables/site-config';
import { getSecureAemSiteIdentifier } from '@/utils/aem';
import { useLedsService } from 'commercial-web-client-utilities/dist/composables/leds-service';
import { dateFormat } from 'commercial-web-client-utilities';
import { LoginHelpErrorCodes } from '@/enums/forgot-username-error-codes';
import { requiredIf } from '@vuelidate/validators';
import { LocaleMessages } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'forgot-password',
  props: {
    i18nMessages: {
        type: Object as PropType<LocaleMessages<unknown>>,
        default: () => ({}),
    },
},
  setup(__props) {

const props = __props;

const firstNameValidationRules = {
    firstName: {
        requiredIf: requiredIf(() => firstNameRequired.value)

    }
};

const nonSecureService = useNonsecureService();
const ledsService = useLedsService();
const passwordHelpService = createPasswordHelpService({
    nonSecureService: nonSecureService,
    ledsService: ledsService
});
const appStore = useAppStore();
const siteConfig = useSiteConfig();
const loginHelpStore = useLoginHelpStore();
const { t } = useI18n();
const i18n = useI18n();
const forgotPasswordFormData = reactive({
    username: '',
    dateOfBirth: ''
});
const firstNameFormData = reactive({
    firstName: ''
});
const showSystemError = ref(false);
const loading = ref(false);
const submitted = ref(false);
const hasTyped = ref(false);
let datePickerDOB: Date | null = null;
const today = new Date();
const blurred = reactive({
    username: false,
    dateOfBirth: false
});
const showAPISuccess = ref(false);
const showResendEmailSuccess = ref(false);
const showTwinError = ref(false);
const firstNameRequired = ref(false);
const showInfoNoMatch = ref<boolean>(false);
const showUserNotFound = ref<boolean>(false);
const v$ = useVuelidate(forgotPasswordRules, forgotPasswordFormData, { $lazy: true, $autoDirty: true });
const firstNamev$ = useVuelidate(firstNameValidationRules, firstNameFormData);
const showFaqModal = ref(false);
const emailAddress = ref<string>('');



watch(() => forgotPasswordFormData.username, (newValue) => {
    blurred.username = false;
    if (!newValue) hasTyped.value = false;
});

watch(() => forgotPasswordFormData.dateOfBirth, () => {
    blurred.dateOfBirth = false;
});

watch(() => props.i18nMessages, (i18nMessages) => {
    mergeMessages(i18n, i18nMessages);
}, { immediate: true });

const handleSubmit = async () => {
    submitted.value = true;
    v$.value.$touch();
    blurred.username = true;
    blurred.dateOfBirth = true;
    if (v$.value.$invalid) {
        logger.log('Password validation failed');
        return;
    }
    loading.value = true;
    loginHelpStore.setUserDetails(
        {
            'dob': forgotPasswordFormData.dateOfBirth,
            'username': forgotPasswordFormData.username
        });
    try {
        loading.value = true;
        const response = await getSecurePasswordResetLink(forgotPasswordFormData.username,
            forgotPasswordFormData.dateOfBirth.toString());
        logger.log('Username retrieved.', response.data);
        emailAddress.value = '********@' + response.data.emailDomain;
        showAPISuccess.value = true;
    } catch (axiosError) {
        const statusCode = (axiosError as AxiosError).response?.status;
        handleLoginHelpError(statusCode);
        logger.error('Failed to retrieve username.', axiosError);
    } finally {
        loading.value = false;
    }
};

async function handleLoginHelpError(statusCode: number | undefined) {
    await resetErrorAlerts();
    switch (statusCode) {
        case LoginHelpErrorCodes.MULTIPLE_MATCHES_ERROR:
            firstNameRequired.value = true;
            showTwinError.value = true;
            break;
        case LoginHelpErrorCodes.REQUESTED_SUBSCRIBER_ERROR:
            showUserNotFound.value = true;
            break;
        case LoginHelpErrorCodes.MEMBER_DOESNT_EXIST_ERROR:
        case LoginHelpErrorCodes.MEMBER_NOT_FOUND_ERROR:
            showUserNotFound.value = true;
            break;
        case LoginHelpErrorCodes.DEPENDENTS_UNDERAGE_ERROR:
            showInfoNoMatch.value = true;
            break;
        default:
            showSystemError.value = true;
            break;
    }
}

async function resetErrorAlerts() {
    firstNameRequired.value = false;
    showSystemError.value = false;
    showTwinError.value = false;
    showInfoNoMatch.value = false;
    showUserNotFound.value = false;
}

async function getSecurePasswordResetLink(username: string, dob: string) {
    return passwordHelpService.getSecurePasswordResetLink({
        username: username,
        dob: dateFormat(dob, 'YYYY-MM-DD'),
        signal: new AbortController().signal
    });
}

/**
     * synchronizes the Date Picker with dateOfservice
     * this is done because if the user enters the date manually in the input field
     * then the date picker should show the same date as the selected date when
     * the user clicks on the calendar
     */
const syncDate = () => {
    const date: Date = new Date(forgotPasswordFormData.dateOfBirth);
    datePickerDOB = date;
    logger.log('Datepicker is synced to input DOB,', datePickerDOB);
};

const onDateOfBirthChange = (date: string) => {
    if (date) {
        const dateObj = new Date(date);
        const month = dateObj.getMonth() + 1; // getMonth() returns 0-11, so add 1
        const day = dateObj.getDate();
        const year = dateObj.getFullYear();

        // Format the date based on the conditions
        const formattedDate = `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;
        forgotPasswordFormData.dateOfBirth = formattedDate;
    }
};

const handleCancel = () => {
    forgotPasswordFormData.username = '';
    forgotPasswordFormData.dateOfBirth = '';
    submitted.value = false;
    blurred.username = false;
    blurred.dateOfBirth = false;
    hasTyped.value = false;
    v$.value.$reset();
    logger.log('Password reset cancelled via cancel button click');
    navigateToLogin();
};

const handleForgotUsername = () => {
    const queryParams = new URLSearchParams();
    queryParams.append('target', 'forgot-username');
    const site = getSecureAemSiteIdentifier();
    if (site) {
        // If site isn't passed, Instil theme will flash blue for a split second.
        queryParams.append('site', site);
    }
    const url = `https://${window.location.hostname}/site-router.html?${queryParams}`;
    logger.log(url, 'url');
    window.location.href = url;
};

async function handleResendEmailClick () {
    const { username, dob } = loginHelpStore.getUserDetails;
    try {
        loading.value = true;
        await getSecurePasswordResetLink(username, dob);
        showResendEmailSuccess.value = true;
    } catch (axiosError) {
        const statusCode = (axiosError as AxiosError).response?.status;
        handleLoginHelpError(statusCode);
        logger.error('Failed to retrieve username.', statusCode);
    } finally {
        loading.value = false;

    }
}

const navigateToLogin = () => {
    window.location.href = appStore.logoutUrl ?? 'https://myhealthtoolkit.com';
};

return (_ctx: any,_cache: any) => {
  const _component_b_alert = _resolveComponent("b-alert")!
  const _component_b_link = _resolveComponent("b-link")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_form_datepicker = _resolveComponent("b-form-datepicker")!
  const _component_b_input_group_append = _resolveComponent("b-input-group-append")!
  const _component_b_input_group = _resolveComponent("b-input-group")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_overlay = _resolveComponent("b-overlay")!
  const _component_b_container = _resolveComponent("b-container")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_b_overlay, {
        show: loading.value,
        variant: "light",
        opacity: "0.75",
        rounded: "sm",
        "data-test-ref": "password-help-overlay"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('passwordHelp.title.forgotPassword')), 1 /* TEXT */),
          (showAPISuccess.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_b_alert, {
                  show: showAPISuccess.value,
                  variant: "success",
                  class: "mt-4 py-2 m-0 align-middle rounded"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('passwordHelp.sendEmailAPISuccess.successMessage',
                             { emailAddress: emailAddress.value })), 1 /* TEXT */)
                    ])
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["show"]),
                _createVNode(_component_b_alert, {
                  show: showResendEmailSuccess.value,
                  variant: "success",
                  class: "mt-4 py-2 m-0 align-middle rounded"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('passwordHelp.sendEmailAPISuccess.resendEmailSuccess')), 1 /* TEXT */)
                    ])
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["show"]),
                _createElementVNode("p", _hoisted_9, [
                  _createVNode(_component_i18n_t, {
                    keypath: "passwordHelp.sendEmailAPISuccess.supportInformation",
                    scope: "global"
                  }, {
                    resendEmail: _withCtx(() => [
                      _createVNode(_component_b_link, {
                        "data-test-ref": "password-help-resend-email-link",
                        onClick: handleResendEmailClick
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.link.resendEmail')), 1 /* TEXT */)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      })
                    ]),
                    technicalSupport: _withCtx(() => [
                      _createVNode(_component_b_link, {
                        "data-test-ref": "password-help-technical-support-link",
                        onClick: _unref(siteConfig).redirectToTechSupport
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.link.technicalSupport')), 1 /* TEXT */)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onClick"])
                    ]),
                    callSupport: _withCtx(() => [
                      _createElementVNode("a", _hoisted_10, _toDisplayString(_unref(t)('passwordHelp.link.technicalSupportNumber')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_b_button, {
                    variant: "primary",
                    type: "submit",
                    "data-test-ref": "password-help-submit-button",
                    onClick: navigateToLogin
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('forgotUsername.email.returnToLogin')), 1 /* TEXT */)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  })
                ])
              ]))
            : (showTwinError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_b_alert, {
                    variant: "warning",
                    show: showTwinError.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(_unref(t)('forgotUsername.infoForm.alerts.requiredFirstNameAlert', {
                                firstNameLabel: _unref(t)('forgotUsername.infoForm.firstName.label')
                            })), 1 /* TEXT */)
                        ])
                      ])
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["show"])
                ]))
              : (showInfoNoMatch.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_component_b_alert, {
                      variant: "warning",
                      show: showInfoNoMatch.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_i18n_t, {
                                keypath: "forgotUsername.infoForm.alerts.requestedSubscriberError",
                                tag: "span"
                              }, {
                                frequentlyAskedQuestions: _withCtx(() => [
                                  _createVNode(_component_b_link, {
                                    "data-test-ref": "member-forgot-username-faq-link",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showFaqModal.value = true))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('forgotUsername.infoForm.alerts.frequentlyAskedQuestions')), 1 /* TEXT */)
                                    ], undefined, true),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ])
                          ])
                        ])
                      ], undefined, true),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["show"])
                  ]))
                : (showSystemError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_component_b_alert, {
                        variant: "danger",
                        show: showSystemError.value
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _hoisted_25,
                              _createTextVNode(" " + _toDisplayString(_unref(t)('forgotUsername.infoForm.alerts.systemError')), 1 /* TEXT */)
                            ])
                          ])
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["show"])
                    ]))
                  : (showUserNotFound.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createVNode(_component_b_alert, {
                          show: showUserNotFound.value,
                          variant: "warning",
                          class: "mt-4 py-2 m-0 align-middle rounded-0"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _createElementVNode("p", null, [
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('passwordHelp.userNotFound[0]')), 1 /* TEXT */),
                                _createVNode(_component_b_link, {
                                  "data-test-ref": "member-forgot-password-faq-link",
                                  class: "text-primary",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showFaqModal.value = true))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.userNotFound[1]')), 1 /* TEXT */)
                                  ], undefined, true),
                                  _: 1 /* STABLE */
                                }),
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('passwordHelp.userNotFound[2]')), 1 /* TEXT */),
                                _createVNode(_component_b_link, {
                                  class: "text-primary",
                                  onClick: handleForgotUsername
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.userNotFound[3]')), 1 /* TEXT */)
                                  ], undefined, true),
                                  _: 1 /* STABLE */
                                })
                              ])
                            ])
                          ], undefined, true),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["show"])
                      ]))
                    : _createCommentVNode("v-if", true),
          (!showAPISuccess.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(t)('passwordHelp.forgotPasswordDescription')), 1 /* TEXT */),
                _createVNode(_component_b_form, {
                  "data-test-ref": "password-help-form",
                  novalidate: "",
                  onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (handleSubmit()), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_b_form_group, {
                          id: "usernameContainer",
                          label: "Username",
                          "label-for": "username",
                          class: "mb-0 w-50"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_b_form_input, {
                              id: "username",
                              modelValue: forgotPasswordFormData.username,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((forgotPasswordFormData.username) = $event)),
                              type: "text",
                              autocomplete: "off",
                              class: _normalizeClass(_unref(v$).username.required.$invalid ? ' border-danger' : ''),
                              "data-test-ref": "username-input"
                            }, null, 8 /* PROPS */, ["modelValue", "class"]), [
                              [_directive_maska]
                            ])
                          ], undefined, true),
                          _: 1 /* STABLE */
                        }),
                        (_unref(v$).username.required.$invalid)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_unref(t)('passwordHelp.error.usernameIsRequired')), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_b_link, {
                            "data-test-ref": "forgot-username",
                            onClick: handleForgotUsername
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.label.forgotUsername')), 1 /* TEXT */)
                            ], undefined, true),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _createVNode(_component_b_form_group, {
                          id: "dobDateContainer",
                          label: "Your date of birth",
                          "label-for": "dateOfBirth",
                          class: "mb-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_input_group, { class: "mb-0 mt-2 w-50" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_b_form_input, {
                                  id: "dateOfBirth",
                                  modelValue: forgotPasswordFormData.dateOfBirth,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((forgotPasswordFormData.dateOfBirth) = $event)),
                                  type: "text",
                                  autocomplete: "off",
                                  maxlength: "10",
                                  "data-maska": "##/##/####",
                                  class: _normalizeClass((_unref(v$).dateOfBirth.required.$invalid || _unref(v$).dateOfBirth.valid.$invalid)
                                            ? ' border-danger' : ''),
                                  "data-test-ref": "dob-input",
                                  onChange: _cache[4] || (_cache[4] = ($event: any) => (syncDate()))
                                }, null, 8 /* PROPS */, ["modelValue", "class"]), [
                                  [_directive_maska]
                                ]),
                                _createVNode(_component_b_input_group_append, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_b_form_datepicker, {
                                      modelValue: _unref(datePickerDOB),
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(datePickerDOB) ? (datePickerDOB).value = $event : datePickerDOB = $event)),
                                      "button-only": "",
                                      class: _normalizeClass((_unref(v$).dateOfBirth.required.$invalid || _unref(v$).dateOfBirth.valid.$invalid)
                                                ? 'border-top border-right border-bottom' : ''),
                                      "button-variant": "outline-primary",
                                      "nav-button-variant": "primary",
                                      right: "",
                                      "show-decade-nav": true,
                                      max: _unref(today),
                                      "value-as-date": true,
                                      locale: "en",
                                      onInput: onDateOfBirthChange
                                    }, null, 8 /* PROPS */, ["modelValue", "class", "max"])
                                  ], undefined, true),
                                  _: 1 /* STABLE */
                                })
                              ], undefined, true),
                              _: 1 /* STABLE */
                            })
                          ], undefined, true),
                          _: 1 /* STABLE */
                        }),
                        (!(_unref(v$).dateOfBirth.required.$invalid || _unref(v$).dateOfBirth.valid.$invalid))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_unref(t)('passwordHelp.dobHelpText')), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        ((_unref(v$).dateOfBirth.required.$invalid || _unref(v$).dateOfBirth.valid.$invalid))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_unref(t)('passwordHelp.error.dobIsRequired')), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        (firstNameRequired.value)
                          ? (_openBlock(), _createBlock(_component_b_form_group, {
                              key: 3,
                              id: "firstNameContainer",
                              label: "Legal first name",
                              "label-for": "memberFirstNameInput",
                              class: "mb-1 mt-3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_b_input_group, { class: "mb-0 mt-2 w-50" }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_b_form_input, {
                                      id: "memberFirstNameInput",
                                      modelValue: firstNameFormData.firstName,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((firstNameFormData.firstName) = $event)),
                                      "data-test-ref": "firstName-input-field",
                                      class: _normalizeClass(_unref(firstNamev$).firstName.requiredIf.$invalid? ' border-danger' : ''),
                                      type: "text",
                                      autocomplete: "off",
                                      trim: ""
                                    }, null, 8 /* PROPS */, ["modelValue", "class"]), [
                                      [_directive_maska]
                                    ])
                                  ], undefined, true),
                                  _: 1 /* STABLE */
                                })
                              ], undefined, true),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true),
                        (_unref(firstNamev$).firstName.requiredIf.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_unref(t)('forgotUsername.infoForm.validations.requiredFirstName')), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _hoisted_38,
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_b_link, {
                        "data-test-ref": "password-help-cancel-button",
                        onClick: handleCancel
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.action.cancel')), 1 /* TEXT */)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_b_button, {
                        variant: "primary",
                        type: "submit",
                        "data-test-ref": "password-help-submit-button"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.action.continue')) + " ", 1 /* TEXT */),
                          _hoisted_40
                        ], undefined, true),
                        _: 1 /* STABLE */
                      })
                    ])
                  ], undefined, true),
                  _: 1 /* STABLE */
                }),
                _createElementVNode("p", _hoisted_41, [
                  _createVNode(_component_i18n_t, {
                    keypath: "passwordHelp.help.furtherAssistance",
                    scope: "global"
                  }, {
                    technicalSupport: _withCtx(() => [
                      _createVNode(_component_b_link, {
                        "data-test-ref": "password-help-technical-support-link",
                        target: "_blank",
                        onClick: _unref(siteConfig).redirectToTechSupport
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.link.technicalSupport')), 1 /* TEXT */)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onClick"])
                    ]),
                    callSupport: _withCtx(() => [
                      _createElementVNode("a", _hoisted_42, _toDisplayString(_unref(t)('passwordHelp.link.technicalSupportNumber')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ], undefined, true),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show"]),
      _createVNode(FaqModal, {
        id: "faqModal",
        modelValue: showFaqModal.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showFaqModal).value = $event)),
        "test-ref": 'forgot-password',
        "hide-footer": true
      }, null, 8 /* PROPS */, ["modelValue"])
    ], undefined, true),
    _: 1 /* STABLE */
  }))
}
}

})